import { render, staticRenderFns } from "./infoRecommendCharge.vue?vue&type=template&id=63253598&scoped=true&"
import script from "./infoRecommendCharge.vue?vue&type=script&lang=js&"
export * from "./infoRecommendCharge.vue?vue&type=script&lang=js&"
import style0 from "./infoRecommendCharge.vue?vue&type=style&index=0&id=63253598&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63253598",
  null
  
)

export default component.exports